/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Markdown_PlaceholderInputs */

const cs_blog_markdown_placeholder = /** @type {(inputs: Blog_Markdown_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pište Markdown. Obrázky používají URL asset://…`)
};

const en_blog_markdown_placeholder = /** @type {(inputs: Blog_Markdown_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write Markdown. Images use asset://… URLs.`)
};

/**
* | output |
* | --- |
* | "Write Markdown. Images use asset://… URLs." |
*
* @param {Blog_Markdown_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_markdown_placeholder = /** @type {((inputs?: Blog_Markdown_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Markdown_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_markdown_placeholder(inputs)
	return cs_blog_markdown_placeholder(inputs)
});